
import { useState } from 'react'

const BannerWidget = () => {
  const [currentBanner, setCurrentBanner] = useState(0)

  const banners = [
    {
      id: 1,
      title: 'Create Your AI Drama',
      subtitle: 'Start your creative journey today',
      cta: 'Get Started',
      ctaLink: '/dramas',
      bgImage: 'https://public.readdy.ai/ai/img_res/b0464763bc3ade78b08dafb82db45009.jpg',
      gradient: 'from-teal-600/80 to-emerald-600/80'
    },
    {
      id: 2,
      title: 'Join Premium',
      subtitle: 'Unlock exclusive features & content',
      cta: 'Learn More',
      ctaLink: '#',
      bgImage: 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20background%20with%20golden%20amber%20and%20warm%20orange%20tones%20premium%20luxury%20feel%20soft%20bokeh%20lights%20cinematic%20quality%20modern%20sophisticated%20design&width=400&height=280&seq=banner2&orientation=landscape',
      gradient: 'from-amber-600/80 to-orange-600/80'
    },
    {
      id: 3,
      title: 'Creator Program',
      subtitle: 'Monetize your AI drama content',
      cta: 'Apply Now',
      ctaLink: '/creators',
      bgImage: 'https://readdy.ai/api/search-image?query=Creative%20abstract%20background%20with%20rose%20pink%20and%20coral%20gradients%20artistic%20film%20creator%20theme%20modern%20elegant%20design%20with%20soft%20light%20effects%20professional%20atmosphere&width=400&height=280&seq=banner3&orientation=landscape',
      gradient: 'from-rose-600/80 to-pink-600/80'
    }
  ]

  const handleBannerClick = (link: string) => {
    if (link !== '#') {
      window.location.href = link
    }
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border overflow-hidden">
      {/* Banner Display */}
      <div 
        className="relative h-[200px] cursor-pointer overflow-hidden"
        onClick={() => handleBannerClick(banners[currentBanner].ctaLink)}
      >
        <img 
          src={banners[currentBanner].bgImage}
          alt={banners[currentBanner].title}
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className={`absolute inset-0 bg-gradient-to-r ${banners[currentBanner].gradient}`}></div>
        
        <div className="relative z-10 h-full flex flex-col justify-center px-5">
          <h3 className="text-white font-bold text-xl leading-tight">
            {banners[currentBanner].title}
          </h3>
          <p className="text-white/90 text-sm mt-2">
            {banners[currentBanner].subtitle}
          </p>
          <button className="mt-4 bg-white text-gray-800 text-sm font-semibold px-5 py-2 rounded-full hover:bg-gray-100 transition-colors w-fit whitespace-nowrap">
            {banners[currentBanner].cta}
          </button>
        </div>

        {/* Sponsored Tag */}
        <div className="absolute top-3 right-3 bg-black/30 text-white/80 text-xs px-2.5 py-1 rounded">
          Ad
        </div>
      </div>

      {/* Banner Navigation Dots */}
      <div className="flex items-center justify-center gap-2 py-3 bg-gray-50">
        {banners.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentBanner(index)}
            className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
              currentBanner === index 
                ? 'bg-teal-500 w-5' 
                : 'bg-gray-300 hover:bg-gray-400'
            }`}
          />
        ))}
      </div>
    </div>
  )
}

export default BannerWidget
